export default "__VITE_PUBLIC_ASSET__0504e37c__"